import { render, staticRenderFns } from "./speedLimit.vue?vue&type=template&id=2667ffe6&"
import script from "./speedLimit.vue?vue&type=script&lang=js&"
export * from "./speedLimit.vue?vue&type=script&lang=js&"
import style0 from "./speedLimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports